import { render, staticRenderFns } from "./Replacement.vue?vue&type=template&id=6296ffd6"
import script from "./Replacement.vue?vue&type=script&lang=js"
export * from "./Replacement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports